import { ModuleConfig } from '@core/interfaces';
import { name as members } from '@modules/Members/reducers/members';

const config: ModuleConfig = {
  name: 'Members',
  baseUrl: '',
  routes: [
    {
      path: '/admin/inbound',
      page: 'InboundHome',
      title: 'Inbound Page',
      exact: true
      //   reducer: {
      //     name: members,
      //     resource: "members",
      //   },
    },
    {
      path: '/admin/inbound/:id',
      page: 'InboundDetail',
      title: 'Inbound Detail Page',
      exact: true
      //   reducer: {
      //     name: members,
      //     resource: "members",
      //   },
    }
  ],
  requireAuthenticated: true
};

export default config;
